export default "__VITE_ASSET__rdbSAohg__"